module.exports = __webpack_public_path__ + "static/chunks/algorithm.76c9e757bcd05f94d6cd.worker.js"